/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'touchstart']; // disable patch specified eventNames
